// extracted by mini-css-extract-plugin
export default {"login":"Login_login__jJiFM","leftImgs":"Login_leftImgs__HLxgU","rightForm":"Login_rightForm__k2YvC","rotate":"Login_rotate__irzac"};